/* eslint-disable */
import { useState } from 'react';
import { useForm } from "react-hook-form";



export default function EmailBox({ setNodes, apisData, id, emailSender, eventData }) {
    const [refresher, setRefresher] = useState(false)
    const [sender, setSender] = useState(apisData.sender)
    const { register } = useForm(

        {
            defaultValues: {
                sender: eventData.value.api.sender,
                subject: eventData.value.api.subject,
                sender_name: eventData.value.api.sender_name,
                content:eventData.value.api.content,
              } || {}  // Initially set default values if available
          }
    );





    // console.log(eventData.value.api.auth_key)
    const senderSet = (val) => {
        setSender(val)
        emailSender.data.map(x => {
            if (x.verify_email == val) {
                setNodes(nds => nds.map(node => {
                    if (node.id == id) {
                        node.data.value.api.sender = x.verify_email
                    }
                    return node;
                }))
            }
        })
        setRefresher(!refresher)
    }

    const setDetail = (val, type) => {
        setNodes(nds => nds.map(node => {
            if (node.id == id) {
                if (type == "subject") {
                    node.data.value.api.subject = val
                } else if (type == "sender_name") {
                    node.data.value.api.sender_name = val
                } else if (type == "content") {
                    node.data.value.api.content = val
                }
            }
            return node;
        }))
    }

    return (
        <div className="card-body mt-0">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <select className="form-select" defaultValue={sender} {...register("sender", { onChange: (e) => senderSet(e.target.value) })} >
                        <option value="" disabled selected>Select Sender</option>
                        {emailSender.data.map(x => <option value={x.verify_email}>{x.verify_email}</option>)}
                    </select>

                    <input {...register("subject", { onChange: (e) => setDetail(e.target.value, "subject") })} className="form-control mb-2" placeholder="Enter the subject" />
                    <input {...register("sender_name", { onChange: (e) => setDetail(e.target.value, "sender_name") })} className="form-control mb-2" placeholder="Enter the Sender Name" />
                    <textarea  {...register("content", { onChange: (e) => setDetail(e.target.value, "content") })} className="form-control mb-2" style={{ overflow: 'hidden', resize: 'none' }} placeholder="Enter the Content" />
                </div>
            </div>
        </div>
    );
}